const DO_LOGIN = 'DO_LOGIN';
const DO_LOGOUT = 'DO_LOGOUT';
const SET_INIT_INFO = 'SET_INIT_INFO';

export default {
  DO_LOGIN,
  DO_LOGOUT,
  SET_INIT_INFO
};
